import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, PdfColor } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import { calcGridRects } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';

export abstract class BackScreenBase implements ILayoutImageGen, IItemCount {
  abstract backgroundColor: PdfColor;
  abstract genName: string;

  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const page = pdf.addPage(true);
    const margin = PdfUnit.FromMillimeters(5);

    const count = Math.min(opts.list.length, this.countMax());
    const { rects } = calcGridRects(count, margin, PdfSize.A4H);

    const brush = new PdfBrush(this.backgroundColor);

    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];
      page.drawRectangle(null, brush, rect);
      page.drawImageCenter(opts.list[i].image, rect);
      page.drawRectangle(GUtil.cutPen, null, rect);
    }
  }
}
